<template>
  <div id="app">
    <!-- 登录页和大屏页不显示布局 -->
    <el-container v-if="!isLoginPage && !isFullPage" class="app-layout">
      <el-header class="app-header" height="50px">
        <div class="header-left">
          <h1 class="app-title" @click="goHome">老酒数字化管理平台</h1>
        </div>
        <div class="header-right" v-if="isLoggedIn">
          <span class="user-name">{{ currentUser?.displayName || currentUser?.username }}</span>
          <el-button v-if="isAdmin" link class="nav-btn" @click="goUsers">用户管理</el-button>
          <el-button link class="nav-btn" @click="goChangePassword">修改密码</el-button>
          <el-button link class="logout-btn" @click="handleLogout">退出登录</el-button>
        </div>
      </el-header>
      <el-container class="app-body">
      <!--
        <el-aside width="220px" class="app-sidebar" v-if="isLoggedIn">
          <el-menu
            :default-active="activeMenu"
            :default-openeds="['1','2','3','4']"
            class="sidebar-menu"
            background-color="#304156"
            text-color="#bfcbd9"
            active-text-color="#409EFF"
            router
          >
            <el-menu-item index="/">
              <el-icon><i class="el-icon-document"></i></el-icon>
              <span>文档管理</span>
            </el-menu-item>

            <el-sub-menu index="1">
              <template #title>
                <el-icon><i class="el-icon-goods"></i></el-icon>
                <span>基酒管理</span>
              </template>
              <el-menu-item index="/liquor">基酒库存</el-menu-item>
              <el-menu-item index="/liquor/statistics">库存统计</el-menu-item>
              <el-menu-item index="/liquor/jar">坛贮老酒</el-menu-item>
              <el-menu-item index="/liquor/aging-log">变更日志</el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="2">
              <template #title>
                <el-icon><i class="el-icon-truck"></i></el-icon>
                <span>包装酒源</span>
              </template>
              <el-menu-item index="/source/handover">清酒交接</el-menu-item>
              <el-menu-item index="/source/transfer">清酒转运</el-menu-item>
              <el-menu-item index="/source/requisition">供盘领用</el-menu-item>
              <el-menu-item index="/source/ledger">酒源台账</el-menu-item>
              <el-menu-item index="/source/notice">通知单</el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="3">
              <template #title>
                <el-icon><i class="el-icon-setting"></i></el-icon>
                <span>设备与留样</span>
              </template>
              <el-menu-item index="/source/sample">留样管理</el-menu-item>
              <el-menu-item index="/source/equipment">设备台账</el-menu-item>
              <el-menu-item index="/source/maintenance">设备维护</el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="4">
              <template #title>
                <el-icon><i class="el-icon-monitor"></i></el-icon>
                <span>可视化</span>
              </template>
              <el-menu-item index="/digital-twin">数字大屏</el-menu-item>
              <el-menu-item index="/mobile/query">移动端查询</el-menu-item>
            </el-sub-menu>
          </el-menu>
        </el-aside>
      -->
        <el-main class="app-main">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
    <!-- 登录页/大屏页全屏 -->
    <router-view v-else />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessageBox } from 'element-plus';
import { authApi } from './api/auth';

export default {
  name: 'App',
  setup() {
    const route = useRoute();
    const router = useRouter();

    const isLoginPage = computed(() => route.name === 'Login');
    const isFullPage = computed(() => route.name === 'DigitalTwinScreen' || route.name === 'MobileNotice' || route.name === 'MobileQuery');
    // 依赖 route.path 以保证登录/退出后重新求值（localStorage 非响应式）
    const isLoggedIn = computed(() => !!route.path && authApi.isLoggedIn());
    const currentUser = computed(() => route.path ? authApi.getCurrentUser() : null);
    const isAdmin = computed(() => {
      const u = route.path ? authApi.getCurrentUser() : null;
      return !!u && u.role === 'admin';
    });
    const activeMenu = computed(() => route.path);

    const handleLogout = async () => {
      try {
        await ElMessageBox.confirm('确认退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        authApi.logout();
        router.push('/login');
      } catch {
        // 取消退出
      }
    };

    const goHome = () => {
      router.push('/');
    };

    const goUsers = () => {
      router.push('/users');
    };

    const goChangePassword = () => {
      router.push('/change-password');
    };

    return {
      isLoginPage,
      isFullPage,
      isLoggedIn,
      currentUser,
      isAdmin,
      activeMenu,
      handleLogout,
      goHome,
      goUsers,
      goChangePassword
    };
  }
}
</script>

<style>
#app {
  height: 100vh;
}

.app-layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-header {
  background: linear-gradient(135deg, #1a3a5c 0%, #2b5f8a 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.15);
  z-index: 10;
}

.app-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  cursor: pointer;
  letter-spacing: 2px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-name {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
}

.logout-btn {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 14px;
}

.logout-btn:hover {
  color: white !important;
}

.nav-btn {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 14px;
}

.nav-btn:hover {
  color: white !important;
}

.app-body {
  flex: 1;
  overflow: hidden;
}

.app-sidebar {
  background-color: #304156;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 2px 0 6px rgba(0,0,0,0.1);
}

.sidebar-menu {
  border-right: none !important;
}

.sidebar-menu .el-menu-item,
.sidebar-menu .el-sub-menu__title {
  height: 46px;
  line-height: 46px;
}

.sidebar-menu .el-menu-item.is-active {
  background-color: #263445 !important;
  border-right: 3px solid #409EFF;
}

.app-main {
  background-color: #f0f2f5;
  padding: 20px;
  overflow-y: auto;
}
</style>